module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Vice.14c0b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Vice.jpg
// module id = Rf1i
// module chunks = 0